import { render, staticRenderFns } from "./Forget.vue?vue&type=template&id=eb39105e&scoped=true"
import script from "./Forget.vue?vue&type=script&lang=js"
export * from "./Forget.vue?vue&type=script&lang=js"
import style0 from "./Forget.vue?vue&type=style&index=0&id=eb39105e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb39105e",
  null
  
)

export default component.exports